import React from 'react';
import {
  Box, VStack, Text, Icon, Avatar,
} from '@gluestack-ui/themed';
import { Wrench } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

const MaintenanceMessage = ({ maintenanceState }) => {
  const { t } = useTranslation();

  const isIgnored = process.env.EXPO_PUBLIC_IGNORE_MAINTENANCE === 'true' && maintenanceState?.isInMaintenance;
  const current = maintenanceState?.currentMaintenance;
  const hasDetails = !!(current?.startTime && current?.endTime);

  const title = isIgnored ? t('maintenance.ignored.title') : !hasDetails ? t('maintenance.unavailable.title') : t('maintenance.active.title');
  const message = isIgnored ? t('maintenance.ignored.message') : !hasDetails ? t('maintenance.system_unavailable') : t('maintenance.active.message', {
    start: new Date(current.startTime).toLocaleString('en-US', {
      month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
    }),
    end: new Date(current.endTime).toLocaleString('en-US', {
      month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
    }),
  });

  return (
    <Box
      bg="$backgroundLight50"
      p="$6"
      $base-w="90%"
      $sm-w={500}
      alignSelf="center"
      borderRadius="$xl"
      shadow="$1"
      borderWidth={1}
      minHeight={200}
      borderColor="$borderLight200"
    >
      <VStack
        flex={1}
        justifyContent="center"
        alignItems="center"
        $sm-flexDirection="row"
        space="lg"
      >
        <Avatar bg={isIgnored ? '$warning200' : '$backgroundLight200'} size="md">
          <Icon as={Wrench} size="lg" color={isIgnored ? '$warning800' : '$textDark800'} />
        </Avatar>

        <VStack space="xs" alignItems="center" $sm-alignItems="flex-start" flexShrink={1}>
          <Text
            size="sm"
            fontWeight="$bold"
            color={isIgnored ? '$warning800' : '$textDark700'}
            testID="maintenance-title"
            textAlign="center"
            $sm-textAlign="left"
          >
            {title}
          </Text>
          <Text
            size="xs"
            color={isIgnored ? '$warning700' : '$textDark600'}
            textAlign="center"
            $sm-textAlign="left"
            testID="maintenance-message"
          >
            {message}
          </Text>
        </VStack>
      </VStack>
    </Box>
  );
};

export default MaintenanceMessage;
